module.exports = "<a (click)=\"voteSummary()\" name=\"Review Ballot\" class=\"reviewText\" [hidden]=\"hideButton\">Review My Ballot</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/ballot-review-btn/ballot-review-btn.component.html
// module id = ./src/app/features/ballot-review-btn/ballot-review-btn.component.html
// module chunks = main